import axios from 'axios';

export function getSendEmailList({ limit, page, filters }) {
    return axios({
        method: 'get',
        url: `/api/v1/sender?limit=${limit}&page=${page}&filters=${JSON.stringify(filters.search.length >= 2 ? filters : {})}`,
        withCredentials: true,
    });
}

export function getSendEmail(id) {
    return axios({
        method: 'get',
        url: `/api/v1/sender/${id}`,
        withCredentials: true,
    });
}




// WEBPACK FOOTER //
// ./app/services/sender.js